import { render } from "./SizeTypeCheckboxes.vue?vue&type=template&id=04890670&scoped=true"
import script from "./SizeTypeCheckboxes.vue?vue&type=script&lang=js"
export * from "./SizeTypeCheckboxes.vue?vue&type=script&lang=js"

import "./SizeTypeCheckboxes.vue?vue&type=style&index=0&id=04890670&scoped=true&lang=css"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04890670"]])

export default __exports__